module.exports = __webpack_public_path__ + "static/media/snowmobile.ac1cdb7e.svg";